import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [teamColors, setTeamColors] = useState({
    primary: '#0ea5e9',
    secondary: '#f97316',
    accent: '#ffffff'
  });

  // Load saved team from localStorage
  useEffect(() => {
    const savedTeam = localStorage.getItem('selectedTeam');
    if (savedTeam) {
      const team = JSON.parse(savedTeam);
      setSelectedTeam(team);
      setTeamColors(team.colors);
      applyThemeToDOM(team.colors);
    }
  }, []);

  const selectTeam = (team) => {
    setSelectedTeam(team);
    setTeamColors(team.colors);
    localStorage.setItem('selectedTeam', JSON.stringify(team));
    applyThemeToDOM(team.colors);
  };

  const clearTeam = () => {
    setSelectedTeam(null);
    setTeamColors({
      primary: '#0ea5e9',
      secondary: '#f97316',
      accent: '#ffffff'
    });
    localStorage.removeItem('selectedTeam');
    applyThemeToDOM({
      primary: '#0ea5e9',
      secondary: '#f97316',
      accent: '#ffffff'
    });
  };

  const applyThemeToDOM = (colors) => {
    const root = document.documentElement;
    
    // Apply CSS custom properties
    root.style.setProperty('--team-primary', colors.primary);
    root.style.setProperty('--team-secondary', colors.secondary);
    root.style.setProperty('--team-accent', colors.accent);
    
    // Update meta theme color for mobile browsers
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', colors.primary);
    }
  };

  const value = {
    selectedTeam,
    teamColors,
    selectTeam,
    clearTeam,
    isTeamSelected: !!selectedTeam
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext; 